import React, {useMemo} from 'react'
import {Grid, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types'
import Button from 'components/Button';

const style = theme => ({
    root: {
        '&>*': {
            flexShrink: 0,
        }
    },
    separator: {
        flexGrow: 1,
    },
    button: {
        width: theme.components.progressBar.buttons.width
    },
    buttonList: {
        marginRight: theme.spacing(2)
    },
    buttonListLeft: {
        marginLeft: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(1),
    }
})

const getButtons = (buttons) => {
    const bb = {
        before: [],
        after: []
    }

    if (buttons)
        buttons.forEach((b) => {
            (b.toLeft ? bb.before : bb.after).push(b);
        })

    return bb;
};

function ButtonsBar(
    {
        classes,
        buttons
    }) {

    const button = ({variant, label, onClick, Icon, color, disabled, toLeft}) => (
        <Grid key={label} item>
            <Button
                className={toLeft ? classes.buttonListLeft : classes.buttonList}
                color={color}
                variant={variant}
                onClick={onClick}
                disabled={disabled}
            >
                {Boolean(Icon) && <Icon className={classes.icon}/>}
                {label}
            </Button>
        </Grid>
    )

    const memoButtons = useMemo(() => getButtons(buttons), [buttons]);

    return (
        <Grid
            container
        >
            {
                memoButtons.before.length ? memoButtons.before.map(b => button(b)) : undefined
            }
            <Grid item className={classes.separator}>
            </Grid>
            {
                memoButtons.after.length ? memoButtons.after.map(b => button(b)) : undefined
            }

        </Grid>
    )
}

ButtonsBar.propTypes = {
    className: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        variant: PropTypes.oneOf(['outlined', 'contained', 'text'])
    }))
}

ButtonsBar.propDefault = {}

export default withStyles(style)(ButtonsBar)
